import { composeRequestKey } from './composeRequestKey';

export const getClientQueryKey = () => composeRequestKey({ name: 'client' });

export const getClientsArrQueryKey = () => composeRequestKey({ name: 'clients' });

export const getAppointmentsQueryKey = () => composeRequestKey({ name: 'appointments' });

export const getClubsQueryKey = () => composeRequestKey({ name: 'clubs' });

export const postAuthClientsKey = () => composeRequestKey({ name: 'auth_clients' });

export const getTicketsQueryKey = () => composeRequestKey({ name: 'tickets' });

export const getPurchaseHistoryQueryKey = () => composeRequestKey({ name: 'purchase' });

export const getBonusesQueryKey = () => composeRequestKey({ name: 'bonuses' });

export const getVisitsHistoryQueryKey = () => composeRequestKey({ name: 'visits_history' });

export const getSwimmersDiaryQueryKey = () => composeRequestKey({ name: 'swimmers_diary' });

export const getAppointmentServicesQuery = () =>
  composeRequestKey({ name: 'appointment_services' });
